var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.contract.version > 1
        ? _c("div", { staticClass: "simple-form " }, [
            _c("div", { staticClass: "form-group center" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "form-value width-1-5x" }, [
                _c("span", [_vm._v(_vm._s(_vm.prevChangeContract.title))])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group center" }, [
              _vm._m(1),
              _vm._v(" "),
              _c("div", { staticClass: "form-value width-1-5x" }, [
                _c("span", [
                  _vm._v(_vm._s(_vm.prevChangeContract.sndPartyHtBh))
                ])
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "content-caption dashed" }, [
        _c("span", [_vm._v("合同信息")]),
        _vm._v(" "),
        _c("div", { staticClass: "fr clearfix" }, [
          _vm.contract.id != null &&
          _vm.contract.confirmed &&
          _vm.contractType != _vm.servcDlgt.value
            ? _c(
                "button",
                {
                  staticClass: "swb-btn swb-btn-mini mr15",
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.toRcvVoucherList($event)
                    }
                  }
                },
                [_c("span", [_vm._v("收款明细")])]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.contract.id != null
            ? _c(
                "button",
                {
                  staticClass: "swb-btn swb-btn-mini mr15",
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.showContractRecord($event)
                    }
                  }
                },
                [_vm._v("合同操作记录")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.contract.id != null &&
          _vm.contract.confirmed &&
          _vm.contractType != _vm.servcDlgt.value
            ? _c(
                "button",
                {
                  staticClass: "swb-btn swb-btn-mini mr15",
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.monitoringData($event)
                    }
                  }
                },
                [_c("span", [_vm._v("合同数据监控")])]
              )
            : _vm._e()
        ]),
        _vm._v(" "),
        _vm.contract.fulfillApplyState != 0
          ? _c("div", { staticClass: "fr clearfix" }, [
              _c("span", { staticClass: "mr15 font14" }, [
                _c("label", [_vm._v("验收完成审核:")]),
                _vm._v(" "),
                _vm.contract.checkAuditState == 0
                  ? _c("span", [_vm._v("未审核")])
                  : _vm._e(),
                _vm._v(" "),
                _vm.contract.checkAuditState == 1
                  ? _c("span", [_vm._v("审核通过")])
                  : _vm._e(),
                _vm._v(" "),
                _vm.contract.checkAuditState == -1
                  ? _c("span", [_vm._v("审核未通过")])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "mr15 font14" }, [
                _c("label", [_vm._v("验收完成申请:")]),
                _vm._v(" "),
                _vm.contract.checkApplyState == 0
                  ? _c("span", [_vm._v("未申请")])
                  : _vm._e(),
                _vm._v(" "),
                _vm.contract.checkApplyState == 1
                  ? _c("span", [_vm._v("已申请")])
                  : _vm._e(),
                _vm._v(" "),
                _vm.contract.checkApplyState == 2
                  ? _c("span", [_vm._v("已处理")])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "mr15 font14" }, [
                _c("label", [_vm._v("履约完成审核:")]),
                _vm._v(" "),
                _vm.contract.fulfillAuditState == 0
                  ? _c("span", [_vm._v("未审核")])
                  : _vm._e(),
                _vm._v(" "),
                _vm.contract.fulfillAuditState == 1
                  ? _c("span", [_vm._v("审核通过")])
                  : _vm._e(),
                _vm._v(" "),
                _vm.contract.fulfillAuditState == -1
                  ? _c("span", [_vm._v("审核未通过")])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "mr15 font14" }, [
                _c("label", [_vm._v("履约完成申请:")]),
                _vm._v(" "),
                _vm.contract.fulfillApplyState == 0
                  ? _c("span", [_vm._v("未申请")])
                  : _vm._e(),
                _vm._v(" "),
                _vm.contract.fulfillApplyState == 1
                  ? _c("span", [_vm._v("已申请")])
                  : _vm._e(),
                _vm._v(" "),
                _vm.contract.fulfillApplyState == 2
                  ? _c("span", [_vm._v("已处理")])
                  : _vm._e()
              ])
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "el-form",
        {
          ref: "contract",
          staticClass: "demo-ruleForm",
          attrs: { model: _vm.contract, rules: _vm.contractRules }
        },
        [
          _c("div", { staticClass: "simple-form flex col-2" }, [
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", { staticClass: "required" }, [
                  _vm._v(_vm._s(_vm.srcMerchant) + "名称")
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value width-2x" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "sndPartyName" } },
                    [
                      _c("el-input", {
                        attrs: { disabled: true },
                        model: {
                          value: _vm.contract.sndPartyName,
                          callback: function($$v) {
                            _vm.$set(_vm.contract, "sndPartyName", $$v)
                          },
                          expression: "contract.sndPartyName"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", { staticClass: "required" }, [_vm._v("卖方公司")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value width-2x" },
                [
                  _c("el-input", {
                    attrs: { disabled: true },
                    model: {
                      value: _vm.contract.sndPartyRealComName,
                      callback: function($$v) {
                        _vm.$set(_vm.contract, "sndPartyRealComName", $$v)
                      },
                      expression: "contract.sndPartyRealComName"
                    }
                  }),
                  _vm._v(" "),
                  _vm.operateContract != "chakan"
                    ? _c("div", {
                        staticClass:
                          "form-tips icon iconfont icon-chazhaobiaodanliebiao relation-icon",
                        attrs: { title: "选择" },
                        on: {
                          click: function($event) {
                            _vm.selectRealCom(false)
                          }
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ]),
            _vm._v(" "),
            _vm.operateContract == "chakan"
              ? _c("div", { staticClass: "form-group center" }, [
                  _c("div", { staticClass: "form-label" }, [
                    _c("label", [_vm._v("原始系统合同编号")])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-value width-2x" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "originalNo" } },
                        [
                          _c("el-input", {
                            attrs: { disabled: true },
                            model: {
                              value: _vm.contract.originalNo,
                              callback: function($$v) {
                                _vm.$set(_vm.contract, "originalNo", $$v)
                              },
                              expression: "contract.originalNo"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.operateContract == "chakan"
              ? _c("div", { staticClass: "form-group center" }, [
                  _c("div", { staticClass: "form-label" }, [
                    _c("label", [_vm._v(_vm._s(_vm.sndMerchant) + "签署人")])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-value width-2x" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "fstPartySigner" } },
                        [
                          _c("el-input", {
                            attrs: { disabled: true },
                            model: {
                              value: _vm.contract.fstPartySigner,
                              callback: function($$v) {
                                _vm.$set(_vm.contract, "fstPartySigner", $$v)
                              },
                              expression: "contract.fstPartySigner"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", { staticClass: "required" }, [_vm._v("合同种类")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value width-2x" },
                [
                  _c(
                    "el-radio-group",
                    {
                      attrs: { disabled: _vm.contract.id != null },
                      on: { change: _vm.kindChange },
                      model: {
                        value: _vm.contract.kindId,
                        callback: function($$v) {
                          _vm.$set(_vm.contract, "kindId", $$v)
                        },
                        expression: "contract.kindId"
                      }
                    },
                    [
                      _c("el-radio", { attrs: { label: 0 } }, [
                        _vm._v("标准合同")
                      ]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v("框架合同")
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _vm.isLegacyContract
              ? _c("div", { staticClass: "form-group center" }, [
                  _c("div", { staticClass: "form-label" }, [
                    _c("label", { staticClass: "required" }, [
                      _vm._v("线下合同")
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-value width-2x" },
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: { disabled: _vm.contract.id != null },
                          model: {
                            value: _vm.contract.offline,
                            callback: function($$v) {
                              _vm.$set(_vm.contract, "offline", $$v)
                            },
                            expression: "contract.offline"
                          }
                        },
                        [
                          _c("el-radio", { attrs: { label: true } }, [
                            _vm._v("是")
                          ]),
                          _vm._v(" "),
                          _c("el-radio", { attrs: { label: false } }, [
                            _vm._v("否")
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", { staticClass: "required" }, [_vm._v("合同名称")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value width-2x" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "title" } },
                    [
                      _c("el-input", {
                        attrs: {
                          disabled:
                            (_vm.disabled || _vm.operateContract == "chakan") &&
                            _vm.operateContract != "change"
                        },
                        model: {
                          value: _vm.contract.title,
                          callback: function($$v) {
                            _vm.$set(_vm.contract, "title", $$v)
                          },
                          expression: "contract.title"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _vm.operateContract == "chakan"
              ? _c("div", { staticClass: "form-group center" }, [
                  _c("div", { staticClass: "form-label" }, [
                    _c("label", [_vm._v(_vm._s(_vm.sndMerchant) + "确认时间")])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-value width-2x" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "fstPartyConfirmTime" } },
                        [
                          _c("el-input", {
                            attrs: { disabled: true },
                            model: {
                              value: _vm.contract.fstPartyConfirmTime,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.contract,
                                  "fstPartyConfirmTime",
                                  $$v
                                )
                              },
                              expression: "contract.fstPartyConfirmTime"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", { staticClass: "required" }, [_vm._v("合同编号")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value width-2x" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "accordHtBh" } },
                    [
                      _c("el-input", {
                        attrs: {
                          disabled:
                            _vm.operateContract == "chakan" ||
                            _vm.operateContract == "change" ||
                            (_vm.operateContract == "edit" &&
                              _vm.contract.creatorRealComId != null &&
                              _vm.scopeEntity.realComId !=
                                _vm.contract.creatorRealComId) ||
                            _vm.contract.version > 1
                        },
                        model: {
                          value: _vm.contract.accordHtBh,
                          callback: function($$v) {
                            _vm.$set(_vm.contract, "accordHtBh", $$v)
                          },
                          expression: "contract.accordHtBh"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _vm.contractType != _vm.servcDlgt.value &&
            _vm.contractType != _vm.servcPurch.value
              ? _c("div", { staticClass: "form-group center" }, [
                  _c("div", { staticClass: "form-label" }, [
                    _c("label", { staticClass: "required" }, [
                      _vm._v("跨订单结算")
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-value width-2x" },
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: { disabled: _vm.contract.id != null },
                          on: { change: _vm.settleChange },
                          model: {
                            value: _vm.contract.settleCrossOrderAllowed,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.contract,
                                "settleCrossOrderAllowed",
                                $$v
                              )
                            },
                            expression: "contract.settleCrossOrderAllowed"
                          }
                        },
                        [
                          _c("el-radio", { attrs: { label: true } }, [
                            _vm._v("是")
                          ]),
                          _vm._v(" "),
                          _c("el-radio", { attrs: { label: false } }, [
                            _vm._v("否")
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.contractType != _vm.servcDlgt.value
              ? _c("div", { staticClass: "form-group center" }, [
                  _c("div", { staticClass: "form-label" }, [
                    _c("label", { staticClass: "required" }, [
                      _vm._v("合同来源")
                    ])
                  ]),
                  _vm._v(" "),
                  _vm.contractType == _vm.integPurch.value
                    ? _c(
                        "div",
                        { staticClass: "form-value width-3x" },
                        [
                          _c(
                            "el-radio-group",
                            {
                              attrs: {
                                disabled:
                                  _vm.contract.srcId != null ||
                                  _vm.contract.fstPartyId != null
                              },
                              model: {
                                value: _vm.contract.srcFlag,
                                callback: function($$v) {
                                  _vm.$set(_vm.contract, "srcFlag", $$v)
                                },
                                expression: "contract.srcFlag"
                              }
                            },
                            _vm._l(_vm.bizSrcFlagList, function(bizSrcFlag) {
                              return bizSrcFlag.name != "DeviceRequire" &&
                                bizSrcFlag.name != "DealInqry" &&
                                bizSrcFlag.name != "PriceInqry"
                                ? _c(
                                    "el-radio",
                                    { attrs: { label: bizSrcFlag.value } },
                                    [
                                      _c("span", [
                                        _vm._v(_vm._s(bizSrcFlag.text))
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            })
                          )
                        ],
                        1
                      )
                    : _c(
                        "div",
                        { staticClass: "form-value width-3x" },
                        [
                          _c(
                            "el-radio-group",
                            {
                              attrs: {
                                disabled:
                                  _vm.contract.srcId != null ||
                                  _vm.contract.fstPartyId != null
                              },
                              model: {
                                value: _vm.contract.srcFlag,
                                callback: function($$v) {
                                  _vm.$set(_vm.contract, "srcFlag", $$v)
                                },
                                expression: "contract.srcFlag"
                              }
                            },
                            _vm._l(_vm.bizSrcFlagList, function(bizSrcFlag) {
                              return bizSrcFlag.name != "DeviceRequire" &&
                                bizSrcFlag.name != "DealInqry"
                                ? _c(
                                    "el-radio",
                                    { attrs: { label: bizSrcFlag.value } },
                                    [
                                      _c("span", [
                                        _vm._v(_vm._s(bizSrcFlag.text))
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            })
                          )
                        ],
                        1
                      )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.contractType != _vm.servcDlgt.value && _vm.contract.srcFlag == 2
              ? _c("div", { staticClass: "form-group center" }, [
                  _c("div", { staticClass: "form-label" }, [
                    _c("label", [_vm._v("投标书")])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-value width-2x" }, [
                    _c(
                      "div",
                      {
                        staticClass: "btn-label-group",
                        staticStyle: {
                          "margin-top": "7px",
                          overflow: "inherit"
                        }
                      },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { prop: "srcWinId" } },
                          [
                            _c(
                              "label",
                              {
                                staticClass: "textfield",
                                staticStyle: { width: "242px" }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.contract.srcName) +
                                    "\n                                    "
                                ),
                                _vm.operateContract != "chakan" &&
                                !_vm.disabled &&
                                _vm.contract.srcWinId != null
                                  ? _c("i", {
                                      staticClass: "cleared",
                                      on: {
                                        click: function($event) {
                                          _vm.deleteCall()
                                        }
                                      }
                                    })
                                  : _vm._e()
                              ]
                            ),
                            _vm._v(" "),
                            _vm.operateContract == "change" ||
                            ((_vm.contract.id == null ||
                              _vm.operateContract == "edit") &&
                              _vm.contract.fstPartyConfirmed == false)
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "swb-btn swb-btn-small fl right-radio",
                                    on: {
                                      click: function($event) {
                                        _vm.showCallBidDocDlg()
                                      }
                                    }
                                  },
                                  [_c("span", [_vm._v("选择投标书")])]
                                )
                              : _c(
                                  "div",
                                  {
                                    staticClass:
                                      "swb-btn swb-btn-small fl swb-btn-disabled right-radio"
                                  },
                                  [_vm._v("选择投标书")]
                                ),
                            _vm._v(" "),
                            _c("el-input", {
                              staticStyle: { display: "none" },
                              attrs: { type: "text" },
                              model: {
                                value: _vm.contract.srcWinId,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.contract,
                                    "srcWinId",
                                    _vm._n($$v)
                                  )
                                },
                                expression: "contract.srcWinId"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", { staticClass: "required" }, [
                  _vm._v(_vm._s(_vm.sndMerchant))
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-value width-2x" }, [
                _c(
                  "div",
                  {
                    staticClass: "btn-label-group",
                    staticStyle: { "margin-top": "7px", overflow: "inherit" }
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { prop: "fstPartyId" } },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "textfield",
                            staticStyle: { width: "242px" }
                          },
                          [_vm._v(_vm._s(_vm.contract.fstPartyName))]
                        ),
                        _vm._v(" "),
                        _vm.contract.id == null
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "swb-btn swb-btn-small fl right-radio",
                                on: {
                                  click: function($event) {
                                    _vm.showMerchantDlg()
                                  }
                                }
                              },
                              [
                                _c("span", [
                                  _vm._v("选择" + _vm._s(_vm.sndMerchant))
                                ])
                              ]
                            )
                          : _c(
                              "div",
                              {
                                staticClass:
                                  "swb-btn swb-btn-small fl swb-btn-disabled right-radio"
                              },
                              [_vm._v("选择" + _vm._s(_vm.sndMerchant))]
                            ),
                        _vm._v(" "),
                        _c("el-input", {
                          staticStyle: { display: "none" },
                          attrs: { type: "text" },
                          model: {
                            value: _vm.contract.fstPartyId,
                            callback: function($$v) {
                              _vm.$set(_vm.contract, "fstPartyId", _vm._n($$v))
                            },
                            expression: "contract.fstPartyId"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", { staticClass: "required" }, [_vm._v("买方公司")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value width-2x" },
                [
                  _c("el-input", {
                    attrs: { disabled: true },
                    model: {
                      value: _vm.contract.fstPartyRealComName,
                      callback: function($$v) {
                        _vm.$set(_vm.contract, "fstPartyRealComName", $$v)
                      },
                      expression: "contract.fstPartyRealComName"
                    }
                  }),
                  _vm._v(" "),
                  _vm.operateContract != "chakan" &&
                  _vm.operateContract != "edit"
                    ? _c("div", {
                        staticClass:
                          "form-tips icon iconfont icon-chazhaobiaodanliebiao relation-icon",
                        attrs: { title: "选择" },
                        on: {
                          click: function($event) {
                            _vm.selectRealCom(true)
                          }
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ]),
            _vm._v(" "),
            _vm.operateContract == "chakan"
              ? _c("div", { staticClass: "form-group center" }, [
                  _c("div", { staticClass: "form-label" }, [
                    _c("label", [_vm._v(_vm._s(_vm.sndMerchant) + "确认人")])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-value width-2x" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "fstPartyConfirmerName" } },
                        [
                          _c("el-input", {
                            attrs: { disabled: true },
                            model: {
                              value: _vm.contract.fstPartyConfirmerName,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.contract,
                                  "fstPartyConfirmerName",
                                  $$v
                                )
                              },
                              expression: "contract.fstPartyConfirmerName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.contractType == _vm.servcPurch.value &&
            _vm.contract.srcFlag == 3
              ? _c("div", { staticClass: "form-group center" }, [
                  _c("div", { staticClass: "form-label" }, [
                    _c("label", [_vm._v("报价单")])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-value width-3x" }, [
                    _c(
                      "div",
                      {
                        staticClass: "btn-label-group",
                        staticStyle: {
                          "margin-top": "7px",
                          overflow: "inherit"
                        }
                      },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { prop: "srcWinId" } },
                          [
                            _c(
                              "label",
                              {
                                staticClass: "textfield",
                                staticStyle: { width: "242px" }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.contract.srcName) +
                                    "\n                                    "
                                ),
                                _vm.operateContract != "chakan" &&
                                !_vm.disabled &&
                                _vm.contract.srcWinId != null
                                  ? _c("i", {
                                      staticClass: "cleared",
                                      on: {
                                        click: function($event) {
                                          _vm.deletePrice()
                                        }
                                      }
                                    })
                                  : _vm._e()
                              ]
                            ),
                            _vm._v(" "),
                            _vm.operateContract == "change" ||
                            ((_vm.contract.id == null ||
                              _vm.operateContract == "edit") &&
                              _vm.contract.fstPartyConfirmed == false &&
                              _vm.contract.fstPartyId != null)
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "swb-btn swb-btn-small fl right-radio",
                                    on: {
                                      click: function($event) {
                                        _vm.showPriceReplyDocDlg()
                                      }
                                    }
                                  },
                                  [_c("span", [_vm._v("选择报价单")])]
                                )
                              : _c(
                                  "div",
                                  {
                                    staticClass:
                                      "swb-btn swb-btn-small fl swb-btn-disabled right-radio"
                                  },
                                  [_vm._v("选择报价单")]
                                ),
                            _vm._v(" "),
                            _c("span", { staticClass: "inline-block ml10" }, [
                              _vm._v(
                                "(请先选择" + _vm._s(_vm.sndMerchant) + ")"
                              )
                            ]),
                            _vm._v(" "),
                            _c("el-input", {
                              staticStyle: { display: "none" },
                              attrs: { type: "text" },
                              model: {
                                value: _vm.contract.srcWinId,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.contract,
                                    "srcWinId",
                                    _vm._n($$v)
                                  )
                                },
                                expression: "contract.srcWinId"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", { staticClass: "required" }, [_vm._v("签署日期")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value width-2x" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "signDate" } },
                    [
                      _c("el-date-picker", {
                        staticClass: "width-2x",
                        attrs: {
                          disabled:
                            (_vm.disabled || _vm.operateContract == "chakan") &&
                            _vm.operateContract != "change",
                          type: "date",
                          placeholder: "选择日期"
                        },
                        on: { change: _vm.changeSignDate },
                        model: {
                          value: _vm.contract.signDate,
                          callback: function($$v) {
                            _vm.$set(_vm.contract, "signDate", $$v)
                          },
                          expression: "contract.signDate"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _vm.operateContract == "chakan"
              ? _c("div", { staticClass: "form-group center" }, [
                  _c("div", { staticClass: "form-label" }, [
                    _c("label", [_vm._v("否认原因")])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-value width-2x" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "denyCause" } },
                        [
                          _c("el-input", {
                            attrs: { type: "textarea", disabled: true },
                            model: {
                              value: _vm.contract.denyCause,
                              callback: function($$v) {
                                _vm.$set(_vm.contract, "denyCause", $$v)
                              },
                              expression: "contract.denyCause"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", { staticClass: "required" }, [_vm._v("起始时间")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value width-2x" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "dateStart" } },
                    [
                      _c("el-date-picker", {
                        staticClass: "width-2x",
                        attrs: {
                          disabled:
                            (_vm.disabled || _vm.operateContract == "chakan") &&
                            _vm.operateContract != "change",
                          type: "date",
                          placeholder: "选择日期"
                        },
                        on: { change: _vm.checkTime },
                        model: {
                          value: _vm.contract.dateStart,
                          callback: function($$v) {
                            _vm.$set(_vm.contract, "dateStart", $$v)
                          },
                          expression: "contract.dateStart"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", { staticClass: "required" }, [_vm._v("结束时间")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value width-2x" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "dateEnd" } },
                    [
                      _c("el-date-picker", {
                        staticClass: "width-2x",
                        attrs: {
                          disabled:
                            (_vm.disabled || _vm.operateContract == "chakan") &&
                            _vm.operateContract != "change",
                          type: "date",
                          placeholder: "选择日期"
                        },
                        on: { change: _vm.checkTime },
                        model: {
                          value: _vm.contract.dateEnd,
                          callback: function($$v) {
                            _vm.$set(_vm.contract, "dateEnd", $$v)
                          },
                          expression: "contract.dateEnd"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", [_vm._v("签署人姓名")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value width-2x" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "sndPartySigner" } },
                    [
                      _c("el-input", {
                        attrs: { disabled: _vm.operateContract == "chakan" },
                        model: {
                          value: _vm.contract.sndPartySigner,
                          callback: function($$v) {
                            _vm.$set(_vm.contract, "sndPartySigner", $$v)
                          },
                          expression: "contract.sndPartySigner"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _vm.forGoods && _vm.contract.kindId == 1
              ? _c("div", { staticClass: "form-group center" }, [
                  _c("div", { staticClass: "form-label" }, [
                    _c("label", [_vm._v("到货期限（天）")])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-value width-2x" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "desireArriveDays" } },
                        [
                          _c("el-input", {
                            staticClass: "width-2x",
                            attrs: {
                              disabled:
                                (_vm.disabled ||
                                  _vm.operateContract == "chakan") &&
                                _vm.operateContract != "change",
                              type: "number"
                            },
                            model: {
                              value: _vm.contract.desireArriveDays,
                              callback: function($$v) {
                                _vm.$set(_vm.contract, "desireArriveDays", $$v)
                              },
                              expression: "contract.desireArriveDays"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", [_vm._v("自用合同标签")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value width-2x" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "sndPartyFlag" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "text",
                          disabled:
                            _vm.operateContract != "change" &&
                            (_vm.disabled || _vm.operateContract == "chakan")
                        },
                        model: {
                          value: _vm.contract.sndPartyFlag,
                          callback: function($$v) {
                            _vm.$set(_vm.contract, "sndPartyFlag", $$v)
                          },
                          expression: "contract.sndPartyFlag"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _vm.contract.version > 1 || _vm.operateContract == "change"
              ? _c("div", { staticClass: "form-group center" }, [
                  _c("div", { staticClass: "form-label" }, [
                    _c("label", [_vm._v("变更简要描述")])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-value width-2x" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "changeDesc" } },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              disabled:
                                _vm.operateContract != "change" &&
                                (_vm.disabled ||
                                  _vm.operateContract == "chakan")
                            },
                            model: {
                              value: _vm.contract.changeDesc,
                              callback: function($$v) {
                                _vm.$set(_vm.contract, "changeDesc", $$v)
                              },
                              expression: "contract.changeDesc"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", [_vm._v("合同摘要")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value width-3x" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "content" } },
                    [
                      _c("el-input", {
                        attrs: {
                          resize: "none",
                          type: "textarea",
                          disabled:
                            _vm.operateContract != "change" &&
                            (_vm.disabled || _vm.operateContract == "chakan")
                        },
                        model: {
                          value: _vm.contract.contractDigest.content,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.contract.contractDigest,
                              "content",
                              $$v
                            )
                          },
                          expression: "contract.contractDigest.content"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _vm.contractType == _vm.integPurch.value ||
            _vm.contractType == _vm.servcPurch.value
              ? _c("div", { staticClass: "form-group center" }, [
                  _c("div", { staticClass: "form-label" }, [
                    _c("label", { staticClass: "required" }, [
                      _vm._v("税率(%)")
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-value width-2x" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "taxRate" } },
                        [
                          _c("el-input", {
                            attrs: {
                              disabled:
                                (_vm.disabled ||
                                  _vm.operateContract == "chakan") &&
                                _vm.operateContract != "change"
                            },
                            on: {
                              change: function($event) {
                                _vm.taxRateChange(_vm.contract.taxRate)
                              }
                            },
                            model: {
                              value: _vm.contract.taxRate,
                              callback: function($$v) {
                                _vm.$set(_vm.contract, "taxRate", $$v)
                              },
                              expression: "contract.taxRate"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.contractType == _vm.integPurch.value
              ? _c("div", { staticClass: "form-group center" }, [
                  _c("div", { staticClass: "form-label" }, [
                    _c("label", [_vm._v("启用区域价格")])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-value width-2x" },
                    [
                      _c("el-checkbox", {
                        attrs: { disabled: true },
                        model: {
                          value: _vm.contract.bizAreaFlag,
                          callback: function($$v) {
                            _vm.$set(_vm.contract, "bizAreaFlag", $$v)
                          },
                          expression: "contract.bizAreaFlag"
                        }
                      })
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", [_vm._v("是否自动结算")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value width-2x" },
                [
                  _c(
                    "el-radio-group",
                    {
                      attrs: { disabled: _vm.operateContract == "chakan" },
                      model: {
                        value: _vm.contract.settleAutoFlag,
                        callback: function($$v) {
                          _vm.$set(_vm.contract, "settleAutoFlag", $$v)
                        },
                        expression: "contract.settleAutoFlag"
                      }
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("是")
                      ]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("否")
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _vm.contract.settleAutoFlag
              ? _c("div", { staticClass: "form-group center" }, [
                  _c("div", { staticClass: "form-label" }, [
                    _c("label", [_vm._v("结算周期(每月x日)")])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-value width-2x" },
                    [
                      _c("el-input-number", {
                        attrs: {
                          controls: false,
                          min: 1,
                          max: 28,
                          disabled: _vm.operateContract == "chakan"
                        },
                        model: {
                          value: _vm.contract.settlePeriodDay,
                          callback: function($$v) {
                            _vm.$set(_vm.contract, "settlePeriodDay", $$v)
                          },
                          expression: "contract.settlePeriodDay"
                        }
                      })
                    ],
                    1
                  )
                ])
              : _vm._e()
          ])
        ]
      ),
      _vm._v(" "),
      _vm.contractType == _vm.integPurch.value
        ? [
            _vm._m(2),
            _vm._v(" "),
            _c("div", { staticClass: "simple-row" }, [
              _c("div", { staticClass: "left" }, [
                (_vm.showBtn === false || _vm.disabledBtn) &&
                _vm.operateContract != "change"
                  ? _c("div", [
                      _c(
                        "button",
                        {
                          staticClass: "swb-btn swb-btn-small swb-btn-disabled"
                        },
                        [_vm._v("选择商品")]
                      )
                    ])
                  : _c("div", [
                      _c(
                        "button",
                        {
                          staticClass: "swb-btn swb-btn-small",
                          on: { click: _vm.showMkuListDlg }
                        },
                        [_vm._v("选择商品")]
                      )
                    ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "table-layout mt10" },
              [
                _c(
                  "el-form",
                  { ref: "contractGoodsList", attrs: { model: _vm.contract } },
                  [
                    _c(
                      "el-table",
                      {
                        ref: "multipleTable",
                        staticStyle: { width: "100%" },
                        attrs: {
                          data: _vm.contract.contractGoodsList,
                          border: "",
                          "tooltip-effect": "dark"
                        }
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            align: "left",
                            prop: "name",
                            label: "商品名称"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "left",
                            prop: "catName",
                            label: "分类"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "left",
                            width: "100px",
                            prop: "brandName",
                            label: "品牌"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: { align: "left", prop: "model", label: "型号" }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "left",
                            prop: "fixedSpec",
                            label: "规格"
                          }
                        }),
                        _vm._v(" "),
                        _vm.contract.kindId == 0
                          ? _c("el-table-column", {
                              attrs: {
                                align: "center",
                                width: "80px",
                                prop: "quantity",
                                label: "数量"
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            prop:
                                              "contractGoodsList." +
                                              scope.$index +
                                              ".quantity"
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            attrs: {
                                              maxlength: 6,
                                              disabled:
                                                (_vm.disabled ||
                                                  _vm.operateContract ==
                                                    "chakan" ||
                                                  scope.row.bizAreaFlag) &&
                                                _vm.operateContract != "change",
                                              type: "text"
                                            },
                                            on: {
                                              change: function($event) {
                                                _vm.goodsAmountOrQuantityChange(
                                                  scope.row,
                                                  scope.$index,
                                                  "quantity"
                                                )
                                              }
                                            },
                                            model: {
                                              value: scope.row.quantity,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  scope.row,
                                                  "quantity",
                                                  _vm._n($$v)
                                                )
                                              },
                                              expression: "scope.row.quantity"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  }
                                }
                              ])
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            width: "60px",
                            prop: "unit",
                            label: "单位"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            width: "100px",
                            prop: "price",
                            label: "统一含税价(元)"
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        prop:
                                          "contractGoodsList." +
                                          scope.$index +
                                          ".price"
                                      }
                                    },
                                    [
                                      _vm.checkActionPerm("view_item_price") ||
                                      _vm.operateContract != "chakan"
                                        ? _c("el-input", {
                                            attrs: {
                                              maxlength: 9,
                                              disabled:
                                                (_vm.disabled ||
                                                  _vm.operateContract ==
                                                    "chakan") &&
                                                _vm.operateContract != "change",
                                              type: "text"
                                            },
                                            on: {
                                              change: function($event) {
                                                _vm.goodsAmountOrQuantityChange(
                                                  scope.row,
                                                  scope.$index,
                                                  "price"
                                                )
                                              }
                                            },
                                            model: {
                                              value: scope.row.price,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  scope.row,
                                                  "price",
                                                  $$v
                                                )
                                              },
                                              expression: "scope.row.price"
                                            }
                                          })
                                        : _c("el-input", {
                                            attrs: {
                                              disabled: "",
                                              type: "text",
                                              value: "没有权限"
                                            }
                                          })
                                    ],
                                    1
                                  )
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "right",
                            width: "100px",
                            label: "税率(%)"
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _vm.checkActionPerm("view_item_price")
                                    ? _c("span", [
                                        _vm._v(_vm._s(scope.row.taxRate))
                                      ])
                                    : _c("span", [_vm._v("没有权限")])
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "right",
                            width: "100px",
                            prop: "ntxPrice",
                            label: "未税价(元)"
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _vm.checkActionPerm("view_item_price")
                                    ? _c("div", [
                                        scope.row.ntxPrice != null
                                          ? _c("span", [
                                              _vm._v(_vm._s(scope.row.ntxPrice))
                                            ])
                                          : _c("span", [_vm._v("0.00")])
                                      ])
                                    : _c("div", [
                                        _c("span", [_vm._v("没有权限")])
                                      ])
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            width: "100",
                            label: "启用区域价格"
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _vm.checkActionPerm("view_item_price") ||
                                  _vm.operateContract != "chakan"
                                    ? _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: scope.row.bizAreaFlag,
                                            expression: "scope.row.bizAreaFlag"
                                          }
                                        ],
                                        attrs: {
                                          type: "checkbox",
                                          disabled: true
                                        },
                                        domProps: {
                                          checked: Array.isArray(
                                            scope.row.bizAreaFlag
                                          )
                                            ? _vm._i(
                                                scope.row.bizAreaFlag,
                                                null
                                              ) > -1
                                            : scope.row.bizAreaFlag
                                        },
                                        on: {
                                          change: function($event) {
                                            var $$a = scope.row.bizAreaFlag,
                                              $$el = $event.target,
                                              $$c = $$el.checked ? true : false
                                            if (Array.isArray($$a)) {
                                              var $$v = null,
                                                $$i = _vm._i($$a, $$v)
                                              if ($$el.checked) {
                                                $$i < 0 &&
                                                  _vm.$set(
                                                    scope.row,
                                                    "bizAreaFlag",
                                                    $$a.concat([$$v])
                                                  )
                                              } else {
                                                $$i > -1 &&
                                                  _vm.$set(
                                                    scope.row,
                                                    "bizAreaFlag",
                                                    $$a
                                                      .slice(0, $$i)
                                                      .concat(
                                                        $$a.slice($$i + 1)
                                                      )
                                                  )
                                              }
                                            } else {
                                              _vm.$set(
                                                scope.row,
                                                "bizAreaFlag",
                                                $$c
                                              )
                                            }
                                          }
                                        }
                                      })
                                    : _c("span", [_vm._v("没有权限")])
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _vm.contract.kindId == 0
                          ? _c("el-table-column", {
                              attrs: {
                                align: "right",
                                width: "100px",
                                prop: "amount",
                                label: "含税小计(元)"
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _vm.checkActionPerm("view_item_price")
                                        ? _c("div", [
                                            scope.row.amount != null
                                              ? _c("span", [
                                                  _vm._v(
                                                    _vm._s(scope.row.amount)
                                                  )
                                                ])
                                              : _c("span", [_vm._v("0.00")])
                                          ])
                                        : _c("div", [
                                            _c("span", [_vm._v("没有权限")])
                                          ])
                                    ]
                                  }
                                }
                              ])
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "right",
                            width: "100px",
                            prop: "wrntPeriod",
                            label: "质保期(月)"
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        prop:
                                          "contractGoodsList." +
                                          scope.$index +
                                          ".wrntPeriod",
                                        rules: {
                                          validator: _vm.inputWrntPeriod,
                                          trigger: "blur"
                                        }
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          maxlength: 3,
                                          disabled:
                                            (_vm.disabled ||
                                              _vm.operateContract ==
                                                "chakan") &&
                                            _vm.operateContract != "change",
                                          type: "text"
                                        },
                                        model: {
                                          value: scope.row.wrntPeriod,
                                          callback: function($$v) {
                                            _vm.$set(
                                              scope.row,
                                              "wrntPeriod",
                                              _vm._n($$v)
                                            )
                                          },
                                          expression: "scope.row.wrntPeriod"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            width: "100px",
                            prop: "asmblAccFlag",
                            label: "组装件"
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        prop:
                                          "contractGoodsList." +
                                          scope.$index +
                                          ".asmblAccFlag"
                                      }
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: scope.row.asmblAccFlag,
                                            expression: "scope.row.asmblAccFlag"
                                          }
                                        ],
                                        attrs: {
                                          type: "checkbox",
                                          disabled:
                                            (_vm.disabled ||
                                              _vm.operateContract ==
                                                "chakan") &&
                                            _vm.operateContract != "change"
                                        },
                                        domProps: {
                                          checked: Array.isArray(
                                            scope.row.asmblAccFlag
                                          )
                                            ? _vm._i(
                                                scope.row.asmblAccFlag,
                                                null
                                              ) > -1
                                            : scope.row.asmblAccFlag
                                        },
                                        on: {
                                          change: function($event) {
                                            var $$a = scope.row.asmblAccFlag,
                                              $$el = $event.target,
                                              $$c = $$el.checked ? true : false
                                            if (Array.isArray($$a)) {
                                              var $$v = null,
                                                $$i = _vm._i($$a, $$v)
                                              if ($$el.checked) {
                                                $$i < 0 &&
                                                  _vm.$set(
                                                    scope.row,
                                                    "asmblAccFlag",
                                                    $$a.concat([$$v])
                                                  )
                                              } else {
                                                $$i > -1 &&
                                                  _vm.$set(
                                                    scope.row,
                                                    "asmblAccFlag",
                                                    $$a
                                                      .slice(0, $$i)
                                                      .concat(
                                                        $$a.slice($$i + 1)
                                                      )
                                                  )
                                              }
                                            } else {
                                              _vm.$set(
                                                scope.row,
                                                "asmblAccFlag",
                                                $$c
                                              )
                                            }
                                          }
                                        }
                                      })
                                    ]
                                  )
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "left",
                            width: "200px",
                            prop: "desc",
                            label: "说明"
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        prop:
                                          "contractGoodsList." +
                                          scope.$index +
                                          ".desc"
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          disabled:
                                            (_vm.disabled ||
                                              _vm.operateContract ==
                                                "chakan") &&
                                            _vm.operateContract != "change",
                                          type: "textarea"
                                        },
                                        model: {
                                          value: scope.row.desc,
                                          callback: function($$v) {
                                            _vm.$set(scope.row, "desc", $$v)
                                          },
                                          expression: "scope.row.desc"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "left",
                            width: "150px",
                            label: "操作",
                            "show-overflow-tooltip": ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _vm.showSave &&
                                  _vm.contract.fstPartyConfirmed == false &&
                                  _vm.contract.srcId == null
                                    ? _c(
                                        "a",
                                        {
                                          staticClass: "swb-btn-link",
                                          on: {
                                            click: function($event) {
                                              _vm.removeGoods(scope.$index)
                                            }
                                          }
                                        },
                                        [_vm._v("移除")]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.checkActionPerm("view_item_price") &&
                                  scope.row.bizAreaFlag
                                    ? _c(
                                        "a",
                                        {
                                          staticClass: "swb-btn-link",
                                          on: {
                                            click: function($event) {
                                              _vm.bizAreaOption(
                                                scope.row,
                                                scope.$index
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("经营区域价格")]
                                      )
                                    : _vm._e()
                                ]
                              }
                            }
                          ])
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _vm.contract.kindId != null && _vm.contract.kindId == 0
              ? _c("div", { staticClass: "simple-form" }, [
                  _c("div", { staticClass: "form-group center" }, [
                    _vm._m(3),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-value width-2x" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.number",
                            value: _vm.contract.estmtGoodsCount,
                            expression: "contract.estmtGoodsCount",
                            modifiers: { number: true }
                          }
                        ],
                        staticStyle: {
                          border: "1px solid #DDDDDD",
                          width: "65px",
                          height: "30px"
                        },
                        attrs: {
                          disabled:
                            _vm.showBtn === false &&
                            _vm.operateContract != "change" &&
                            _vm.showAmtAndCot
                        },
                        domProps: { value: _vm.contract.estmtGoodsCount },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.contract,
                              "estmtGoodsCount",
                              _vm._n($event.target.value)
                            )
                          },
                          blur: function($event) {
                            _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", [_vm._v("件")])
                    ])
                  ])
                ])
              : _vm._e()
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm._m(4),
      _vm._v(" "),
      _vm._l(_vm.contract.contractAppliedShopList, function(
        contractAppliedShop,
        index
      ) {
        return _c(
          "el-tag",
          {
            key: contractAppliedShop.shopName,
            staticClass: "mr5",
            attrs: { type: "info" }
          },
          [_c("span", [_vm._v(_vm._s(contractAppliedShop.shopName))])]
        )
      }),
      _vm._v(" "),
      _vm._m(5),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table-layout mt10", staticStyle: { overflow: "auto" } },
        [
          _c(
            "el-form",
            { ref: "contractServcList", attrs: { model: _vm.contract } },
            [
              _c("table", { staticClass: "custom-tbl error-prompt" }, [
                _c("thead", { staticClass: "head" }, [
                  _c("tr", { staticClass: "row" }, [
                    _c(
                      "th",
                      {
                        staticClass: "text-align: left;",
                        attrs: { width: "200" }
                      },
                      [_vm._v("设备维保分组")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "text-align: left;",
                        attrs: { width: "150" }
                      },
                      [_vm._v("资产品牌")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "text-align: left;",
                        attrs: { width: "150" }
                      },
                      [_vm._v("服务类型")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "text-align: left;",
                        attrs: { width: "150" }
                      },
                      [_vm._v("商品分类")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "text-align: left;",
                        attrs: { width: "200" }
                      },
                      [_vm._v("服务内容")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "text-align: left;",
                        attrs: { width: "80" }
                      },
                      [_vm._v("仅部件报修")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "text-align: left;",
                        attrs: { width: "300" }
                      },
                      [_vm._v("设备部件")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "text-align: left;",
                        attrs: { width: "200" }
                      },
                      [_vm._v("服务项目")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "text-align: right;",
                        attrs: { width: "140" }
                      },
                      [_vm._v("上门费(元)")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "text-align: right;",
                        attrs: { width: "140" }
                      },
                      [_vm._v("服务费(元)")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "text-align: right;",
                        attrs: { width: "140" }
                      },
                      [_vm._v("要求响应时长(分钟)")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "text-align: right;",
                        attrs: { width: "140" }
                      },
                      [_vm._v("要求到达时长(分钟)")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "text-align: right;",
                        attrs: { width: "140" }
                      },
                      [_vm._v("要求维修时长(分钟)")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "text-align: right;",
                        attrs: { width: "120" }
                      },
                      [_vm._v("要求质保时长(天)")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "text-align: right;",
                        attrs: { width: "140" }
                      },
                      [_vm._v("电话回询时限(分钟)")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "text-align: right;",
                        attrs: { width: "200" }
                      },
                      [_vm._v("服务次数")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "text-align: right;",
                        attrs: { width: "140" }
                      },
                      [_vm._v("服务次数允许修订")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "text-align: right;",
                        attrs: { width: "140" }
                      },
                      [_vm._v("小计(元)")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "text-align: right;",
                        attrs: { width: "140" }
                      },
                      [_vm._v("开始时间")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "text-align: right;",
                        attrs: { width: "140" }
                      },
                      [_vm._v("结束时间")]
                    ),
                    _vm._v(" "),
                    _c("th", { attrs: { width: "150" } }, [_vm._v("操作")])
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "tbody",
                  { staticClass: "body" },
                  _vm._l(_vm.contract.contractServcList, function(item, index) {
                    return _c("tr", { staticClass: "row" }, [
                      _c("td", [
                        _c("span", { staticClass: "fl" }, [
                          _vm._v(_vm._s(item.devcGroupFullName || ""))
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop:
                                  "contractServcList." +
                                  index +
                                  ".innerDevcBrandId"
                              }
                            },
                            [
                              _c("span", { staticClass: "fl" }, [
                                _vm._v(_vm._s(item.innerDevcBrandName || ""))
                              ])
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("td", [
                        _c("span", [_vm._v(_vm._s(item.servcTypeName || ""))])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("span", { staticClass: "fl" }, [
                          _vm._v(_vm._s(item.goodsCatName || ""))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("span", { staticClass: "fl" }, [
                          _vm._v(_vm._s(item.servcSpec || ""))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        item.devcPartsOnly != null
                          ? _c("span", { staticClass: "fl" }, [
                              _vm._v(_vm._s(item.devcPartsOnly ? "是" : "否"))
                            ])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("span", { staticClass: "fl" }, [
                          _vm._v(_vm._s(item.devcParts || ""))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("span", { staticClass: "fl" }, [
                          _vm._v(_vm._s(item.title || ""))
                        ]),
                        _vm._v(" "),
                        _vm.operateContract != "chakan" && !_vm.disabled
                          ? _c(
                              "a",
                              {
                                staticClass: "swb-btn-link fr",
                                on: {
                                  click: function($event) {
                                    _vm.showMsuListDlg(item, index, false)
                                  }
                                }
                              },
                              [_vm._v("选择")]
                            )
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop:
                                  "contractServcList." + index + ".toDoorFee",
                                rules: {
                                  validator: _vm.moneyCheck,
                                  trigger: "blur"
                                }
                              }
                            },
                            [
                              _vm.checkActionPerm("view_item_price") ||
                              _vm.operateContract != "chakan"
                                ? _c("el-input", {
                                    attrs: {
                                      type: "number",
                                      min: 0,
                                      disabled:
                                        (_vm.disabled ||
                                          _vm.operateContract == "chakan") &&
                                        _vm.operateContract != "change"
                                    },
                                    on: {
                                      change: function($event) {
                                        _vm.toDoorFeeChange(index, false)
                                      }
                                    },
                                    model: {
                                      value: item.toDoorFee,
                                      callback: function($$v) {
                                        _vm.$set(item, "toDoorFee", $$v)
                                      },
                                      expression: "item.toDoorFee"
                                    }
                                  })
                                : _c("el-input", {
                                    attrs: {
                                      disabled: "",
                                      type: "text",
                                      value: "没有权限"
                                    }
                                  })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop: "contractServcList." + index + ".price",
                                rules: {
                                  validator: _vm.moneyCheck,
                                  trigger: "blur"
                                }
                              }
                            },
                            [
                              _vm.checkActionPerm("view_item_price") ||
                              _vm.operateContract != "chakan"
                                ? _c("el-input", {
                                    attrs: {
                                      type: "number",
                                      min: 0,
                                      disabled:
                                        (_vm.disabled ||
                                          _vm.operateContract == "chakan") &&
                                        _vm.operateContract != "change"
                                    },
                                    on: {
                                      change: function($event) {
                                        _vm.priceChange(index, false)
                                      }
                                    },
                                    model: {
                                      value: item.price,
                                      callback: function($$v) {
                                        _vm.$set(item, "price", $$v)
                                      },
                                      expression: "item.price"
                                    }
                                  })
                                : _c("el-input", {
                                    attrs: {
                                      disabled: "",
                                      type: "text",
                                      value: "没有权限"
                                    }
                                  })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop:
                                  "contractServcList." + index + ".rspTimeMi",
                                rules: {
                                  validator: _vm.timeMiCheck,
                                  trigger: "blur"
                                }
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "number",
                                  min: 0,
                                  disabled:
                                    (_vm.disabled ||
                                      _vm.operateContract == "chakan") &&
                                    _vm.operateContract != "change"
                                },
                                model: {
                                  value: item.rspTimeMi,
                                  callback: function($$v) {
                                    _vm.$set(item, "rspTimeMi", _vm._n($$v))
                                  },
                                  expression: "item.rspTimeMi"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop:
                                  "contractServcList." +
                                  index +
                                  ".arriveTimeMi",
                                rules: {
                                  validator: _vm.timeMiCheck,
                                  trigger: "blur"
                                }
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "number",
                                  min: 0,
                                  disabled:
                                    (_vm.disabled ||
                                      _vm.operateContract == "chakan") &&
                                    _vm.operateContract != "change"
                                },
                                model: {
                                  value: item.arriveTimeMi,
                                  callback: function($$v) {
                                    _vm.$set(item, "arriveTimeMi", _vm._n($$v))
                                  },
                                  expression: "item.arriveTimeMi"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop:
                                  "contractServcList." +
                                  index +
                                  ".repairedTimeMi",
                                rules: {
                                  validator: _vm.timeMiCheck,
                                  trigger: "blur"
                                }
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "number",
                                  min: 0,
                                  disabled:
                                    (_vm.disabled ||
                                      _vm.operateContract == "chakan") &&
                                    _vm.operateContract != "change"
                                },
                                model: {
                                  value: item.repairedTimeMi,
                                  callback: function($$v) {
                                    _vm.$set(
                                      item,
                                      "repairedTimeMi",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression: "item.repairedTimeMi"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop:
                                  "contractServcList." + index + ".wrntPeriod",
                                rules: {
                                  validator: _vm.timeMiCheck,
                                  trigger: "blur"
                                }
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "number",
                                  min: 0,
                                  disabled:
                                    (_vm.disabled ||
                                      _vm.operateContract == "chakan") &&
                                    _vm.operateContract != "change"
                                },
                                model: {
                                  value: item.wrntPeriod,
                                  callback: function($$v) {
                                    _vm.$set(item, "wrntPeriod", _vm._n($$v))
                                  },
                                  expression: "item.wrntPeriod"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop:
                                  "contractServcList." +
                                  index +
                                  ".telCallTimeMi",
                                rules: {
                                  validator: _vm.timeMiCheck,
                                  trigger: "blur"
                                }
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "number",
                                  min: 0,
                                  disabled:
                                    (_vm.disabled ||
                                      _vm.operateContract == "chakan") &&
                                    _vm.operateContract != "change"
                                },
                                model: {
                                  value: item.telCallTimeMi,
                                  callback: function($$v) {
                                    _vm.$set(item, "telCallTimeMi", _vm._n($$v))
                                  },
                                  expression: "item.telCallTimeMi"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop:
                                  "contractServcList." +
                                  index +
                                  ".timesLimitType"
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    disabled:
                                      (_vm.disabled ||
                                        _vm.operateContract == "chakan") &&
                                      _vm.operateContract != "change"
                                  },
                                  on: {
                                    change: function($event) {
                                      _vm.timesLimitTypeChange(index, false)
                                    }
                                  },
                                  model: {
                                    value: item.timesLimitType,
                                    callback: function($$v) {
                                      _vm.$set(item, "timesLimitType", $$v)
                                    },
                                    expression: "item.timesLimitType"
                                  }
                                },
                                _vm._l(_vm.timesLimitTypeList, function(
                                  timesLimitType
                                ) {
                                  return _c("el-option", {
                                    key: timesLimitType.value,
                                    attrs: {
                                      disabled:
                                        (_vm.disabled ||
                                          _vm.operateContract == "chakan") &&
                                        _vm.operateContract != "change",
                                      label: timesLimitType.text,
                                      value: timesLimitType.value
                                    }
                                  })
                                })
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          item.timesLimitType == 0
                            ? [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      prop:
                                        "contractServcList." +
                                        index +
                                        ".quantity",
                                      rules: {
                                        validator: _vm.quantityCheck,
                                        trigger: "blur"
                                      }
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        type: "number",
                                        min: 0,
                                        disabled:
                                          (_vm.disabled ||
                                            _vm.operateContract == "chakan") &&
                                          _vm.operateContract != "change"
                                      },
                                      on: {
                                        change: function($event) {
                                          _vm.quantityChange(index, false)
                                        }
                                      },
                                      model: {
                                        value: item.quantity,
                                        callback: function($$v) {
                                          _vm.$set(
                                            item,
                                            "quantity",
                                            _vm._n($$v)
                                          )
                                        },
                                        expression: "item.quantity"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            : _vm._e()
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop:
                                  "contractServcList." +
                                  index +
                                  ".quantityRevisible"
                              }
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: item.quantityRevisible,
                                    expression: "item.quantityRevisible"
                                  }
                                ],
                                attrs: {
                                  type: "checkbox",
                                  disabled:
                                    (_vm.disabled ||
                                      _vm.operateContract == "chakan") &&
                                    _vm.operateContract != "change"
                                },
                                domProps: {
                                  checked: Array.isArray(item.quantityRevisible)
                                    ? _vm._i(item.quantityRevisible, null) > -1
                                    : item.quantityRevisible
                                },
                                on: {
                                  change: function($event) {
                                    var $$a = item.quantityRevisible,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            item,
                                            "quantityRevisible",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            item,
                                            "quantityRevisible",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(item, "quantityRevisible", $$c)
                                    }
                                  }
                                }
                              })
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("td", [
                        _vm.checkActionPerm("view_item_price")
                          ? _c("span", [_vm._v(_vm._s(item.amount))])
                          : _c("span", [_vm._v("没有权限")])
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop:
                                  "contractServcList." + index + ".dateStart",
                                rules: {
                                  validator: _vm.checkDateStart,
                                  trigger: "change"
                                }
                              }
                            },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "120px" },
                                attrs: {
                                  disabled:
                                    (_vm.disabled ||
                                      _vm.operateContract == "chakan") &&
                                    _vm.operateContract != "change",
                                  type: "date",
                                  placeholder: "选择日期"
                                },
                                model: {
                                  value: item.dateStart,
                                  callback: function($$v) {
                                    _vm.$set(item, "dateStart", $$v)
                                  },
                                  expression: "item.dateStart"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop: "contractServcList." + index + ".dateEnd",
                                rules: {
                                  validator: _vm.checkDateEnd,
                                  trigger: "change"
                                }
                              }
                            },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "120px" },
                                attrs: {
                                  disabled:
                                    (_vm.disabled ||
                                      _vm.operateContract == "chakan") &&
                                    _vm.operateContract != "change",
                                  type: "date",
                                  placeholder: "选择日期"
                                },
                                model: {
                                  value: item.dateEnd,
                                  callback: function($$v) {
                                    _vm.$set(item, "dateEnd", $$v)
                                  },
                                  expression: "item.dateEnd"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("td", [
                        _vm.showSave &&
                        _vm.contract.fstPartyConfirmed == false &&
                        _vm.contract.srcId == null
                          ? _c(
                              "div",
                              {
                                staticClass: "swb-btn swb-btn-link",
                                on: {
                                  click: function($event) {
                                    _vm.removeContractServc(index, false)
                                  }
                                }
                              },
                              [_c("span", [_vm._v("移除")])]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.contract.srcId == null &&
                        _vm.contract.id != null &&
                        _vm.contract.contractAppliedShopList != null &&
                        _vm.contract.contractAppliedShopList.length > 0
                          ? _c(
                              "div",
                              {
                                staticClass: "swb-btn swb-btn-link",
                                on: {
                                  click: function($event) {
                                    _vm.setOrgSpecInfo(
                                      index,
                                      item.servcTypeId,
                                      item.timesLimitType,
                                      item.quantityRevisible,
                                      false
                                    )
                                  }
                                }
                              },
                              [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      item.timesLimitType != 1
                                        ? "设置特定门店价格"
                                        : "设置门店次数和价格"
                                    )
                                  )
                                ])
                              ]
                            )
                          : _vm._e()
                      ])
                    ])
                  })
                ),
                _vm._v(" "),
                _c("tfoot", { staticClass: "foot" }, [
                  _c("tr", { staticClass: "row" }, [
                    _vm.contract.fstPartyId != null &&
                    _vm.contract.fstPartyId > 0 &&
                    (_vm.showBtn === true || !_vm.disabledBtn) &&
                    _vm.operateContract != "chakan"
                      ? _c(
                          "td",
                          {
                            staticStyle: {
                              padding: "10px",
                              border: "1px solid #dfe6ec",
                              "text-align": "center"
                            },
                            attrs: { colspan: "19" }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "swb-btn swb-btn-link",
                                on: {
                                  click: function($event) {
                                    _vm.addContractServc(false)
                                  }
                                }
                              },
                              [
                                _c("i", {
                                  staticClass: "icon iconfont icon-jiahao mr5"
                                }),
                                _vm._v(" "),
                                _c("a", { attrs: { href: "#" } }, [
                                  _vm._v("添加")
                                ])
                              ]
                            )
                          ]
                        )
                      : _vm._e()
                  ])
                ])
              ])
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm._m(6),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table-layout", staticStyle: { overflow: "auto" } },
        [
          _c(
            "el-form",
            { ref: "contractServc2List", attrs: { model: _vm.contract } },
            [
              _c("table", { staticClass: "custom-tbl error-prompt" }, [
                _c("thead", { staticClass: "head" }, [
                  _c("tr", { staticClass: "row" }, [
                    _c(
                      "th",
                      {
                        staticClass: "text-align: left;",
                        attrs: { width: "150" }
                      },
                      [_vm._v("服务类型")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "text-align: left;",
                        attrs: { width: "200" }
                      },
                      [_vm._v("常规服务需求")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "text-align: left;",
                        attrs: { width: "200" }
                      },
                      [_vm._v("服务内容")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "text-align: left;",
                        attrs: { width: "200" }
                      },
                      [_vm._v("服务项目")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "text-align: right;",
                        attrs: { width: "140" }
                      },
                      [_vm._v("上门费(元)")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "text-align: right;",
                        attrs: { width: "140" }
                      },
                      [_vm._v("服务费(元)")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "text-align: right;",
                        attrs: { width: "140" }
                      },
                      [_vm._v("要求响应时长(分钟)")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "text-align: right;",
                        attrs: { width: "140" }
                      },
                      [_vm._v("要求到达时长(分钟)")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "text-align: right;",
                        attrs: { width: "140" }
                      },
                      [_vm._v("要求维修时长(分钟)")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "text-align: right;",
                        attrs: { width: "120" }
                      },
                      [_vm._v("要求质保时长(天)")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "text-align: right;",
                        attrs: { width: "140" }
                      },
                      [_vm._v("电话回询时限(分钟)")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "text-align: right;",
                        attrs: { width: "200" }
                      },
                      [_vm._v("服务次数")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "text-align: right;",
                        attrs: { width: "140" }
                      },
                      [_vm._v("服务次数允许修订")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "text-align: right;",
                        attrs: { width: "140" }
                      },
                      [_vm._v("小计(元)")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "text-align: right;",
                        attrs: { width: "140" }
                      },
                      [_vm._v("开始时间")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "text-align: right;",
                        attrs: { width: "140" }
                      },
                      [_vm._v("结束时间")]
                    ),
                    _vm._v(" "),
                    _c("th", { attrs: { width: "150" } }, [_vm._v("操作")])
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "tbody",
                  { staticClass: "body" },
                  _vm._l(_vm.contract.contractServc2List, function(
                    item,
                    index
                  ) {
                    return _c("tr", { staticClass: "row" }, [
                      _c("td", [
                        _c("span", [_vm._v(_vm._s(item.servcTypeName || ""))])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("span", { staticClass: "fl" }, [
                          _vm._v(_vm._s(item.comnRequireTitle || ""))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("span", { staticClass: "fl" }, [
                          _vm._v(_vm._s(item.servcSpec || ""))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("span", { staticClass: "fl" }, [
                          _vm._v(_vm._s(item.title || ""))
                        ]),
                        _vm._v(" "),
                        _vm.operateContract != "chakan" && !_vm.disabled
                          ? _c(
                              "a",
                              {
                                staticClass: "swb-btn-link fr",
                                on: {
                                  click: function($event) {
                                    _vm.showMsuListDlg(item, index, true)
                                  }
                                }
                              },
                              [_vm._v("选择")]
                            )
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop:
                                  "contractServc2List." + index + ".toDoorFee",
                                rules: {
                                  validator: _vm.moneyCheck,
                                  trigger: "blur"
                                }
                              }
                            },
                            [
                              _vm.checkActionPerm("view_item_price") ||
                              _vm.operateContract != "chakan"
                                ? _c("el-input", {
                                    attrs: {
                                      type: "number",
                                      min: 0,
                                      disabled:
                                        (_vm.disabled ||
                                          _vm.operateContract == "chakan") &&
                                        _vm.operateContract != "change"
                                    },
                                    on: {
                                      change: function($event) {
                                        _vm.toDoorFeeChange(index, true)
                                      }
                                    },
                                    model: {
                                      value: item.toDoorFee,
                                      callback: function($$v) {
                                        _vm.$set(item, "toDoorFee", $$v)
                                      },
                                      expression: "item.toDoorFee"
                                    }
                                  })
                                : _c("el-input", {
                                    attrs: {
                                      disabled: "",
                                      type: "text",
                                      value: "没有权限"
                                    }
                                  })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop: "contractServc2List." + index + ".price",
                                rules: {
                                  validator: _vm.moneyCheck,
                                  trigger: "blur"
                                }
                              }
                            },
                            [
                              _vm.checkActionPerm("view_item_price") ||
                              _vm.operateContract != "chakan"
                                ? _c("el-input", {
                                    attrs: {
                                      type: "number",
                                      min: 0,
                                      disabled:
                                        (_vm.disabled ||
                                          _vm.operateContract == "chakan") &&
                                        _vm.operateContract != "change"
                                    },
                                    on: {
                                      change: function($event) {
                                        _vm.priceChange(index, true)
                                      }
                                    },
                                    model: {
                                      value: item.price,
                                      callback: function($$v) {
                                        _vm.$set(item, "price", $$v)
                                      },
                                      expression: "item.price"
                                    }
                                  })
                                : _c("el-input", {
                                    attrs: {
                                      disabled: "",
                                      type: "text",
                                      value: "没有权限"
                                    }
                                  })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop:
                                  "contractServc2List." + index + ".rspTimeMi",
                                rules: {
                                  validator: _vm.timeMiCheck,
                                  trigger: "blur"
                                }
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "number",
                                  min: 0,
                                  disabled:
                                    (_vm.disabled ||
                                      _vm.operateContract == "chakan") &&
                                    _vm.operateContract != "change"
                                },
                                model: {
                                  value: item.rspTimeMi,
                                  callback: function($$v) {
                                    _vm.$set(item, "rspTimeMi", _vm._n($$v))
                                  },
                                  expression: "item.rspTimeMi"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop:
                                  "contractServc2List." +
                                  index +
                                  ".arriveTimeMi",
                                rules: {
                                  validator: _vm.timeMiCheck,
                                  trigger: "blur"
                                }
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "number",
                                  min: 0,
                                  disabled:
                                    (_vm.disabled ||
                                      _vm.operateContract == "chakan") &&
                                    _vm.operateContract != "change"
                                },
                                model: {
                                  value: item.arriveTimeMi,
                                  callback: function($$v) {
                                    _vm.$set(item, "arriveTimeMi", _vm._n($$v))
                                  },
                                  expression: "item.arriveTimeMi"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop:
                                  "contractServc2List." +
                                  index +
                                  ".repairedTimeMi",
                                rules: {
                                  validator: _vm.timeMiCheck,
                                  trigger: "blur"
                                }
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "number",
                                  min: 0,
                                  disabled:
                                    (_vm.disabled ||
                                      _vm.operateContract == "chakan") &&
                                    _vm.operateContract != "change"
                                },
                                model: {
                                  value: item.repairedTimeMi,
                                  callback: function($$v) {
                                    _vm.$set(
                                      item,
                                      "repairedTimeMi",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression: "item.repairedTimeMi"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop:
                                  "contractServc2List." + index + ".wrntPeriod",
                                rules: {
                                  validator: _vm.timeMiCheck,
                                  trigger: "blur"
                                }
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "number",
                                  min: 0,
                                  disabled:
                                    (_vm.disabled ||
                                      _vm.operateContract == "chakan") &&
                                    _vm.operateContract != "change"
                                },
                                model: {
                                  value: item.wrntPeriod,
                                  callback: function($$v) {
                                    _vm.$set(item, "wrntPeriod", _vm._n($$v))
                                  },
                                  expression: "item.wrntPeriod"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop:
                                  "contractServc2List." +
                                  index +
                                  ".telCallTimeMi",
                                rules: {
                                  validator: _vm.timeMiCheck,
                                  trigger: "blur"
                                }
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "number",
                                  min: 0,
                                  disabled:
                                    (_vm.disabled ||
                                      _vm.operateContract == "chakan") &&
                                    _vm.operateContract != "change"
                                },
                                model: {
                                  value: item.telCallTimeMi,
                                  callback: function($$v) {
                                    _vm.$set(item, "telCallTimeMi", _vm._n($$v))
                                  },
                                  expression: "item.telCallTimeMi"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop:
                                  "contractServcList." +
                                  index +
                                  ".timesLimitType"
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    disabled:
                                      (_vm.disabled ||
                                        _vm.operateContract == "chakan") &&
                                      _vm.operateContract != "change"
                                  },
                                  on: {
                                    change: function($event) {
                                      _vm.timesLimitTypeChange(index, true)
                                    }
                                  },
                                  model: {
                                    value: item.timesLimitType,
                                    callback: function($$v) {
                                      _vm.$set(item, "timesLimitType", $$v)
                                    },
                                    expression: "item.timesLimitType"
                                  }
                                },
                                _vm._l(_vm.timesLimitTypeList, function(
                                  timesLimitType
                                ) {
                                  return _c("el-option", {
                                    key: timesLimitType.value,
                                    attrs: {
                                      disabled:
                                        (_vm.disabled ||
                                          _vm.operateContract == "chakan") &&
                                        _vm.operateContract != "change",
                                      label: timesLimitType.text,
                                      value: timesLimitType.value
                                    }
                                  })
                                })
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          item.timesLimitType == 0
                            ? [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      prop:
                                        "contractServc2List." +
                                        index +
                                        ".quantity",
                                      rules: {
                                        validator: _vm.quantityCheck,
                                        trigger: "blur"
                                      }
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        type: "number",
                                        disabled:
                                          (_vm.disabled ||
                                            _vm.operateContract == "chakan") &&
                                          _vm.operateContract != "change",
                                        min: 0
                                      },
                                      on: {
                                        change: function($event) {
                                          _vm.quantityChange(index, true)
                                        }
                                      },
                                      model: {
                                        value: item.quantity,
                                        callback: function($$v) {
                                          _vm.$set(
                                            item,
                                            "quantity",
                                            _vm._n($$v)
                                          )
                                        },
                                        expression: "item.quantity"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            : _vm._e()
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop:
                                  "contractServcList." +
                                  index +
                                  ".quantityRevisible"
                              }
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: item.quantityRevisible,
                                    expression: "item.quantityRevisible"
                                  }
                                ],
                                attrs: {
                                  type: "checkbox",
                                  disabled:
                                    (_vm.disabled ||
                                      _vm.operateContract == "chakan") &&
                                    _vm.operateContract != "change"
                                },
                                domProps: {
                                  checked: Array.isArray(item.quantityRevisible)
                                    ? _vm._i(item.quantityRevisible, null) > -1
                                    : item.quantityRevisible
                                },
                                on: {
                                  change: function($event) {
                                    var $$a = item.quantityRevisible,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            item,
                                            "quantityRevisible",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            item,
                                            "quantityRevisible",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(item, "quantityRevisible", $$c)
                                    }
                                  }
                                }
                              })
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("td", [
                        _vm.checkActionPerm("view_item_price")
                          ? _c("span", [_vm._v(_vm._s(item.amount))])
                          : _c("span", [_vm._v("没有权限")])
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop:
                                  "contractServc2List." + index + ".dateStart",
                                rules: {
                                  validator: _vm.checkDateStart,
                                  trigger: "change"
                                }
                              }
                            },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "120px" },
                                attrs: {
                                  disabled:
                                    (_vm.disabled ||
                                      _vm.operateContract == "chakan") &&
                                    _vm.operateContract != "change",
                                  type: "date",
                                  placeholder: "选择日期"
                                },
                                model: {
                                  value: item.dateStart,
                                  callback: function($$v) {
                                    _vm.$set(item, "dateStart", $$v)
                                  },
                                  expression: "item.dateStart"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop:
                                  "contractServc2List." + index + ".dateEnd",
                                rules: {
                                  validator: _vm.checkDateEnd,
                                  trigger: "change"
                                }
                              }
                            },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "120px" },
                                attrs: {
                                  disabled:
                                    (_vm.disabled ||
                                      _vm.operateContract == "chakan") &&
                                    _vm.operateContract != "change",
                                  type: "date",
                                  placeholder: "选择日期"
                                },
                                model: {
                                  value: item.dateEnd,
                                  callback: function($$v) {
                                    _vm.$set(item, "dateEnd", $$v)
                                  },
                                  expression: "item.dateEnd"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("td", [
                        _vm.showSave &&
                        _vm.contract.fstPartyConfirmed == false &&
                        _vm.contract.srcId == null
                          ? _c(
                              "div",
                              {
                                staticClass: "swb-btn swb-btn-link",
                                on: {
                                  click: function($event) {
                                    _vm.removeContractServc(index, true)
                                  }
                                }
                              },
                              [_c("span", [_vm._v("移除")])]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.contract.srcId == null &&
                        _vm.contract.id != null &&
                        _vm.contract.contractAppliedShopList != null &&
                        _vm.contract.contractAppliedShopList.length > 0
                          ? _c(
                              "div",
                              {
                                staticClass: "swb-btn swb-btn-link",
                                on: {
                                  click: function($event) {
                                    _vm.setOrgSpecInfo(
                                      index,
                                      item.servcTypeId,
                                      item.timesLimitType,
                                      item.quantityRevisible,
                                      true
                                    )
                                  }
                                }
                              },
                              [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      item.timesLimitType != 1
                                        ? "设置特定门店价格"
                                        : "设置门店次数和价格"
                                    )
                                  )
                                ])
                              ]
                            )
                          : _vm._e()
                      ])
                    ])
                  })
                ),
                _vm._v(" "),
                _c("tfoot", { staticClass: "foot" }, [
                  _c("tr", { staticClass: "row" }, [
                    _vm.contract.fstPartyId != null &&
                    _vm.contract.fstPartyId > 0 &&
                    (_vm.showBtn === true || !_vm.disabledBtn) &&
                    _vm.operateContract != "chakan"
                      ? _c(
                          "td",
                          {
                            staticStyle: {
                              padding: "10px",
                              border: "1px solid #dfe6ec",
                              "text-align": "center"
                            },
                            attrs: { colspan: "16" }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "swb-btn swb-btn-link",
                                on: {
                                  click: function($event) {
                                    _vm.addContractServc(true)
                                  }
                                }
                              },
                              [
                                _c("i", {
                                  staticClass: "icon iconfont icon-jiahao mr5"
                                }),
                                _vm._v(" "),
                                _c("a", { attrs: { href: "#" } }, [
                                  _vm._v("添加")
                                ])
                              ]
                            )
                          ]
                        )
                      : _vm._e()
                  ])
                ])
              ])
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.contractType != _vm.servcDlgt.value &&
      _vm.contract.kindId != null &&
      _vm.contract.kindId == 0
        ? _c("div", { staticClass: "simple-form" }, [
            _c("div", { staticClass: "form-group" }, [
              _vm._m(7),
              _vm._v(" "),
              _c("div", { staticClass: "form-value width-2x" }, [
                _vm.checkActionPerm("view_total_price") ||
                _vm.operateContract != "chakan"
                  ? _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.number",
                          value: _vm.contract.estmtAmount,
                          expression: "contract.estmtAmount",
                          modifiers: { number: true }
                        }
                      ],
                      staticStyle: {
                        border: "1px solid #DDDDDD",
                        width: "100px",
                        height: "30px"
                      },
                      attrs: {
                        disabled:
                          (_vm.showBtn === false || _vm.disabledBtn) &&
                          _vm.operateContract != "change" &&
                          _vm.showAmtAndCot
                      },
                      domProps: { value: _vm.contract.estmtAmount },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.contract,
                            "estmtAmount",
                            _vm._n($event.target.value)
                          )
                        },
                        blur: function($event) {
                          _vm.$forceUpdate()
                        }
                      }
                    })
                  : _c("input", {
                      staticStyle: {
                        border: "1px solid #DDDDDD",
                        width: "65px",
                        height: "30px"
                      },
                      attrs: { disabled: "", value: "没有权限" }
                    }),
                _vm._v("元\n                    "),
                _vm.checkActionPerm("view_total_price")
                  ? _c("span", [
                      _vm._v(
                        "(含服务包死价" +
                          _vm._s(
                            _vm.contract.totalServcAmount == null ||
                              _vm.contract.totalServcAmount == ""
                              ? 0
                              : _vm.contract.totalServcAmount
                                  .toFixed(0)
                                  .replace(
                                    /\d{1,3}(?=(\d{3})+(\.\d*)?$)/g,
                                    "$&,"
                                  )
                          ) +
                          "元)"
                      )
                    ])
                  : _vm._e()
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _vm._m(8),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value width-2x" },
                [
                  _c(
                    "el-checkbox",
                    {
                      attrs: {
                        disabled:
                          (_vm.showBtn === false || _vm.disabledBtn) &&
                          _vm.operateContract != "change" &&
                          _vm.showAmtAndCot
                      },
                      on: { change: _vm.servcAmountFixedChange },
                      model: {
                        value: _vm.contract.servcAmountFixed,
                        callback: function($$v) {
                          _vm.$set(_vm.contract, "servcAmountFixed", $$v)
                        },
                        expression: "contract.servcAmountFixed"
                      }
                    },
                    [_c("span", [_vm._v("服务是否包死价")])]
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _vm.contract.servcAmountFixed
              ? _c("div", { staticClass: "form-group" }, [
                  _vm._m(9),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-value width-2x" },
                    [
                      _vm.checkActionPerm("view_total_price")
                        ? _c("el-input", {
                            staticStyle: {
                              border: "1px solid #DDDDDD",
                              width: "65px",
                              height: "30px"
                            },
                            attrs: {
                              disabled:
                                (_vm.showBtn === false || _vm.disabledBtn) &&
                                _vm.operateContract != "change" &&
                                _vm.showAmtAndCot
                            },
                            on: { change: _vm.servcAmountChange },
                            model: {
                              value: _vm.contract.totalServcAmount,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.contract,
                                  "totalServcAmount",
                                  _vm._n($$v)
                                )
                              },
                              expression: "contract.totalServcAmount"
                            }
                          })
                        : _vm._e(),
                      _vm._v("\n                    元\n                    "),
                      !_vm.checkActionPerm("view_total_price")
                        ? _c("input", {
                            staticStyle: {
                              border: "1px solid #DDDDDD",
                              width: "65px",
                              height: "30px"
                            },
                            attrs: { disabled: true, value: "没有权限" }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ])
              : _vm._e()
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._m(10),
      _vm._v(" "),
      _c(
        "div",
        [
          _c(
            "el-checkbox-group",
            {
              attrs: { disabled: _vm.operateContract == "chakan" },
              on: { change: _vm.changeWorkFeeType },
              model: {
                value: _vm.contract.settleInvolvedFeeTypeIds,
                callback: function($$v) {
                  _vm.$set(_vm.contract, "settleInvolvedFeeTypeIds", $$v)
                },
                expression: "contract.settleInvolvedFeeTypeIds"
              }
            },
            _vm._l(_vm.workFeeTypeList, function(workFeeType) {
              return _c(
                "el-checkbox",
                { staticClass: "mt10", attrs: { label: workFeeType.value } },
                [_vm._v(_vm._s(workFeeType.text))]
              )
            })
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm._m(11),
      _vm._v(" "),
      _vm._m(12),
      _vm._v(" "),
      _c("div", { staticClass: "simple-form flex col-3 label" }, [
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(13),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-value" },
            [
              _c(
                "el-select",
                {
                  attrs: { disabled: _vm.operateContract == "chakan" },
                  model: {
                    value: _vm.contract.useAccAuditRule,
                    callback: function($$v) {
                      _vm.$set(_vm.contract, "useAccAuditRule", $$v)
                    },
                    expression: "contract.useAccAuditRule"
                  }
                },
                _vm._l(_vm.accAuditRuleList, function(accAuditRule) {
                  return _c("el-option", {
                    attrs: {
                      label: accAuditRule.text,
                      value: accAuditRule.value
                    }
                  })
                })
              )
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _vm.contract.useAccAuditRule
        ? _c("div", { staticClass: "simple-form flex col-3 label" }, [
            _c("div", { staticClass: "form-group center" }, [
              _vm._m(14),
              _vm._v(" "),
              _c("div", { staticClass: "form-value" }, [
                _c(
                  "div",
                  [
                    _c("el-checkbox", {
                      staticClass: "mt10",
                      attrs: { disabled: _vm.operateContract == "chakan" },
                      model: {
                        value: _vm.contract.sglAccAuditEnabled,
                        callback: function($$v) {
                          _vm.$set(_vm.contract, "sglAccAuditEnabled", $$v)
                        },
                        expression: "contract.sglAccAuditEnabled"
                      }
                    }),
                    _vm._v(
                      "\n                        单个配件大于\n\n                        "
                    ),
                    _c("el-input-number", {
                      attrs: {
                        controls: false,
                        min: 0,
                        disabled: _vm.operateContract == "chakan"
                      },
                      model: {
                        value: _vm.contract.sglAccAmntLimit,
                        callback: function($$v) {
                          _vm.$set(_vm.contract, "sglAccAmntLimit", $$v)
                        },
                        expression: "contract.sglAccAmntLimit"
                      }
                    }),
                    _vm._v(
                      "\n                        元需要审批\n\n                    "
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c("el-checkbox", {
                      staticClass: "mt10",
                      attrs: { disabled: _vm.operateContract == "chakan" },
                      model: {
                        value: _vm.contract.sumAccAuditEnabled,
                        callback: function($$v) {
                          _vm.$set(_vm.contract, "sumAccAuditEnabled", $$v)
                        },
                        expression: "contract.sumAccAuditEnabled"
                      }
                    }),
                    _vm._v(
                      "\n                        工单配件总金额大于\n\n                        "
                    ),
                    _c("el-input-number", {
                      attrs: {
                        controls: false,
                        min: 0,
                        disabled: _vm.operateContract == "chakan"
                      },
                      model: {
                        value: _vm.contract.sumAccAmntLimit,
                        callback: function($$v) {
                          _vm.$set(_vm.contract, "sumAccAmntLimit", $$v)
                        },
                        expression: "contract.sumAccAmntLimit"
                      }
                    }),
                    _vm._v(
                      "\n                        元需要审批\n\n                    "
                    )
                  ],
                  1
                )
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.contract.fstPartyId != null
        ? [
            _c(
              "el-form",
              {
                ref: "contractInvoice",
                staticClass: "demo-ruleForm",
                attrs: { model: _vm.contract, rules: _vm.contractRules }
              },
              [
                _c("div", { staticClass: "simple-form flex col-2" }, [
                  _c("div", { staticClass: "content-caption dashed" }, [
                    _c("span", [_vm._v("发票信息")])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group center" }, [
                    _c("div", { staticClass: "form-label" }, [
                      _c("label", { staticClass: "required" }, [
                        _vm._v("发票类型")
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "form-value width-2x mt5" },
                      [
                        _c("el-form-item", { attrs: { prop: "invoiceType" } }, [
                          (_vm.disabled || _vm.operateContract == "chakan") &&
                          _vm.operateContract != "change"
                            ? _c("div", [
                                _c(
                                  "ul",
                                  { staticClass: "enum-list" },
                                  [
                                    _vm._l(
                                      _vm.merchantInvoiceTypeList,
                                      function(merchantInvoiceType) {
                                        return _c(
                                          "li",
                                          {
                                            staticClass: "enum-item",
                                            class: {
                                              checked:
                                                merchantInvoiceType.value ==
                                                _vm.contract.invoiceType
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(merchantInvoiceType.name)
                                            ),
                                            _c("i")
                                          ]
                                        )
                                      }
                                    ),
                                    _vm._v(" "),
                                    (!_vm.contract.hasInvoiceType ||
                                      (_vm.merchantInvoiceTypeList || [])
                                        .length <= 0) &&
                                    _vm.contract.oldInvoiceType > 0
                                      ? _c(
                                          "li",
                                          {
                                            staticClass: "enum-item",
                                            class: {
                                              checked:
                                                _vm.contract.oldInvoiceType ==
                                                _vm.contract.invoiceType
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(
                                                  _vm.invoiceTypeMap[
                                                    _vm.contract.oldInvoiceType
                                                  ]
                                                )
                                            ),
                                            _c("i")
                                          ]
                                        )
                                      : _vm._e()
                                  ],
                                  2
                                )
                              ])
                            : _c("div", [
                                _c(
                                  "ul",
                                  { staticClass: "enum-list" },
                                  [
                                    _vm._l(
                                      _vm.merchantInvoiceTypeList,
                                      function(merchantInvoiceType) {
                                        return _c(
                                          "li",
                                          {
                                            staticClass: "enum-item",
                                            class: {
                                              checked:
                                                merchantInvoiceType.value ==
                                                _vm.contract.invoiceType
                                            },
                                            on: {
                                              click: function($event) {
                                                _vm.checkInvoiceType(
                                                  merchantInvoiceType.value
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(merchantInvoiceType.name)
                                            ),
                                            _c("i")
                                          ]
                                        )
                                      }
                                    ),
                                    _vm._v(" "),
                                    (!_vm.contract.hasInvoiceType ||
                                      (_vm.merchantInvoiceTypeList || [])
                                        .length <= 0) &&
                                    _vm.contract.oldInvoiceType > 0
                                      ? _c(
                                          "li",
                                          {
                                            staticClass: "enum-item",
                                            class: {
                                              checked:
                                                _vm.contract.oldInvoiceType ==
                                                _vm.contract.invoiceType
                                            },
                                            on: {
                                              click: function($event) {
                                                _vm.checkInvoiceType(
                                                  _vm.contract.oldInvoiceType
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(
                                                  _vm.invoiceTypeMap[
                                                    _vm.contract.oldInvoiceType
                                                  ]
                                                )
                                            ),
                                            _c("i")
                                          ]
                                        )
                                      : _vm._e()
                                  ],
                                  2
                                )
                              ])
                        ])
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group center" }, [
                    _c("div", { staticClass: "form-label" }, [
                      _c("label", [_vm._v("发票抬头")])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "form-value width-2x" },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { prop: "invoiceTitle" } },
                          [
                            _c("el-input", {
                              attrs: {
                                disabled:
                                  (_vm.disabled ||
                                    _vm.operateContract == "chakan") &&
                                  _vm.operateContract != "change"
                              },
                              model: {
                                value: _vm.contract.invoiceTitle,
                                callback: function($$v) {
                                  _vm.$set(_vm.contract, "invoiceTitle", $$v)
                                },
                                expression: "contract.invoiceTitle"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group center" }, [
                    _c("div", { staticClass: "form-label" }, [
                      _c("label", [_vm._v("发票内容标签")])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "form-value width-2x mt5" },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { prop: "invoiceContentTag" } },
                          [
                            (_vm.disabled || _vm.operateContract == "chakan") &&
                            _vm.operateContract != "change"
                              ? _c("div", [
                                  _c(
                                    "ul",
                                    { staticClass: "enum-list" },
                                    _vm._l(_vm.invoiceContentTagList, function(
                                      invoiceContentTag
                                    ) {
                                      return _c(
                                        "li",
                                        {
                                          staticClass: "enum-item",
                                          class: {
                                            checked:
                                              invoiceContentTag.name ==
                                              _vm.contract.invoiceContentTag
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                                            " +
                                              _vm._s(invoiceContentTag.name)
                                          ),
                                          _c("i")
                                        ]
                                      )
                                    })
                                  )
                                ])
                              : _c("div", [
                                  _c(
                                    "ul",
                                    { staticClass: "enum-list" },
                                    _vm._l(_vm.invoiceContentTagList, function(
                                      invoiceContentTag
                                    ) {
                                      return _c(
                                        "li",
                                        {
                                          staticClass: "enum-item",
                                          class: {
                                            checked:
                                              invoiceContentTag.name ==
                                              _vm.contract.invoiceContentTag
                                          },
                                          on: {
                                            click: function($event) {
                                              _vm.checkinvoiceContentTag(
                                                invoiceContentTag.name
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                                            " +
                                              _vm._s(invoiceContentTag.name)
                                          ),
                                          _c("i")
                                        ]
                                      )
                                    })
                                  )
                                ])
                          ]
                        )
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group center" }, [
                    _c("div", { staticClass: "form-label" }, [
                      _c("label", { staticClass: "required" }, [
                        _vm._v("纳税人识别号")
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "form-value width-2x" },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { prop: "taxPayerNo" } },
                          [
                            _c("el-input", {
                              attrs: {
                                disabled:
                                  (_vm.disabled ||
                                    _vm.operateContract == "chakan") &&
                                  _vm.operateContract != "change"
                              },
                              model: {
                                value: _vm.contract.taxPayerNo,
                                callback: function($$v) {
                                  _vm.$set(_vm.contract, "taxPayerNo", $$v)
                                },
                                expression: "contract.taxPayerNo"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ])
              ]
            )
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm._m(15),
      _vm._v(" "),
      _c("div", { staticClass: "simple-form flex col-3 label" }, [
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(16),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-value" },
            [
              _c("el-input", {
                staticClass: "width-1-5x bottom-line",
                attrs: { disabled: "", type: "text" },
                model: {
                  value: _vm.contract.sndPartyCardNo,
                  callback: function($$v) {
                    _vm.$set(_vm.contract, "sndPartyCardNo", $$v)
                  },
                  expression: "contract.sndPartyCardNo"
                }
              }),
              _vm._v(" "),
              _vm.operateContract != "chakan"
                ? _c("div", {
                    staticClass:
                      "form-tips icon iconfont icon-chazhaobiaodanliebiao relation-icon",
                    attrs: { title: "选择" },
                    on: {
                      click: function($event) {
                        _vm.selectBackAcct()
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.operateContract != "chakan" &&
              (_vm.contract.sndPartyCardNo != null ||
                _vm.contract.sndPartyCardNo != "")
                ? _c("div", {
                    staticClass:
                      "form-tips icon iconfont icon-fanhui relation-icon",
                    attrs: { title: "移除" },
                    on: {
                      click: function($event) {
                        _vm.clearBackAcct()
                      }
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(17),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-value" },
            [
              _c("el-input", {
                staticClass: "width-1-5x bottom-line",
                attrs: { disabled: "", type: "text" },
                model: {
                  value: _vm.contract.sndPartyBankName,
                  callback: function($$v) {
                    _vm.$set(_vm.contract, "sndPartyBankName", $$v)
                  },
                  expression: "contract.sndPartyBankName"
                }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(18),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-value" },
            [
              _c("el-input", {
                staticClass: "width-1-5x bottom-line",
                attrs: { disabled: "", type: "text" },
                model: {
                  value: _vm.contract.sndPartyAcctName,
                  callback: function($$v) {
                    _vm.$set(_vm.contract, "sndPartyAcctName", $$v)
                  },
                  expression: "contract.sndPartyAcctName"
                }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(19),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-value" },
            [
              _c("el-input", {
                staticClass: "width-1-5x bottom-line",
                attrs: { disabled: "", type: "text" },
                model: {
                  value: _vm.contract.sndPartyAcctNo,
                  callback: function($$v) {
                    _vm.$set(_vm.contract, "sndPartyAcctNo", $$v)
                  },
                  expression: "contract.sndPartyAcctNo"
                }
              })
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _vm.contractType != _vm.servcDlgt.value &&
      !_vm.contract.settleCrossOrderAllowed
        ? [
            _vm.contract.phaseFlag
              ? [
                  _vm._m(20),
                  _vm._v(" "),
                  _c("swb-contract-track-phase", {
                    ref: "swb_contract_track_phase",
                    attrs: {
                      contractId: _vm.contract.id,
                      offline: _vm.contract.offline,
                      estmtAmount: _vm.contract.estmtAmount,
                      estmtGoodsCount: _vm.contract.estmtGoodsCount,
                      contractType: _vm.contractType,
                      operate: _vm.operateContract
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "simple-form" }, [
                    _c("div", { staticClass: "form-group center" }, [
                      _vm._m(21),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-value width-3x" },
                        [
                          _c(
                            "el-radio-group",
                            {
                              attrs: {
                                disabled:
                                  _vm.contract.id != null &&
                                  _vm.operateContract != "change"
                              },
                              model: {
                                value: _vm.contract.trackByPhase,
                                callback: function($$v) {
                                  _vm.$set(_vm.contract, "trackByPhase", $$v)
                                },
                                expression: "contract.trackByPhase"
                              }
                            },
                            [
                              _c("el-radio", { attrs: { label: false } }, [
                                _c("span", [_vm._v("否")])
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: true } }, [
                                _c("span", [_vm._v("是")])
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ])
                  ])
                ]
              : _vm._e()
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm._m(22),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(23),
        _vm._v(" "),
        _vm.showUpload ||
        (_vm.contract.contractFileList != null &&
          _vm.contract.contractFileList.length > 0)
          ? _c(
              "div",
              { staticClass: "form-value" },
              [
                _c("swb-save-file", {
                  ref: "swb_contract_file",
                  attrs: {
                    showDelete: _vm.showSave,
                    files: _vm.contract.contractFileList
                  }
                })
              ],
              1
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.contractType != _vm.servcDlgt.value && _vm.contract.termsFlag
        ? _c("div", { staticClass: "content-caption dashed" }, [
            _c("span", [_vm._v("条款信息")])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.contractType != _vm.servcDlgt.value && _vm.contract.termsFlag
        ? _c("swb-create-trade-rule", {
            ref: "swb_create_trade_rule",
            attrs: {
              comparedTradeRuleList: _vm.comparedTradeRuleList,
              type: _vm.tradeType,
              operate: _vm.tradeOperate,
              isOwner: false,
              forBid: _vm.forBid,
              forContract: _vm.forContract,
              forGoods: _vm.forGoods,
              forServc: _vm.forServc,
              forPriceInqry: _vm.forPriceInqry
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "form-toolbar" }, [
        _c(
          "button",
          {
            staticClass: "swb-btn swb-btn-small swb-btn-primary",
            on: { click: _vm.prevContract }
          },
          [_vm._v("返回")]
        ),
        _vm._v(" "),
        _vm.showSave && _vm.operateContract == "change"
          ? _c(
              "button",
              {
                staticClass: "swb-btn swb-btn-small",
                on: { click: _vm.registerContract }
              },
              [_vm._v("变更")]
            )
          : _vm._e(),
        _vm._v(" "),
        !_vm.contract.closed &&
        _vm.operateContract != "change" &&
        _vm.operateContract != "chakan"
          ? _c(
              "button",
              {
                staticClass: "swb-btn swb-btn-small",
                on: { click: _vm.registerContract }
              },
              [_c("span", [_vm._v("保存")])]
            )
          : _vm._e()
      ])
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("变更前合同名称：")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("变更前合同编号：")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("商品信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("预计商品总件数：")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("适用机构")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("设备维保服务")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("常规服务请求")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("预计合同总额：")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v(" ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("服务包死价总额：")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("纳入结算单费用项")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("配件信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "simple-form flex col-3 label" }, [
      _c("div", { staticClass: "form-group center" }, [
        _c("div", { staticClass: "form-label" }, [
          _c("label", [_vm._v("配件审核规则")])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("服务商配件")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [_c("label")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("付款信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("收款银行卡号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("银行名称")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("账号名称")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("银行账号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("履约阶段")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", { staticClass: "required" }, [_vm._v("是否按阶段履约")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("附件信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("  ")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-174b9699", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-174b9699","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/contract/RegisterComnSellerContract.vue
// module id = 2077
// module chunks = 1